<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
    style="background-color: red"
    v-resize="onResize"
  >
    <v-card
      v-if="isReady"
      class="standard-row pt-2 pl-10 pb-7"
      style="border: 1px solid #000000; border-radius: 20px"
    >
      <v-card-title class="pa-0">
        <v-row
          no-gutters
          class="standard-row justify-end"
          style="width: 100%; font-size: 12px; padding: 9px 14px 9px 0px"
        >
          <div v-if="permissionGlAccount">
            <v-btn
              v-if="!editFile"
              rounded
              color="#fb8c00"
              class="font-theme white--text download-report-Item-btn"
              @click="editFileData"
            >
              <v-icon class="mr-1">mdi-pen</v-icon> แก้ไขข้อมูล
            </v-btn>
            <v-btn
              v-if="editFile"
              rounded
              color="red"
              :disabled="loadingAddItem === true"
              class="mr-3 font-theme white--text download-report-Item-btn"
              @click="cancelEdit"
            >
              <v-icon class="mr-1">mdi-close</v-icon> ยกเลิก
            </v-btn>

            <v-btn
              v-if="editFile"
              rounded
              color="green"
              :loading="loadingAddItem"
              class="font-theme white--text download-report-Item-btn"
              @click="saveEditItem"
            >
              <v-icon class="mr-1">mdi-content-save</v-icon> บันทึก
            </v-btn>
          </div>
        </v-row>
      </v-card-title>
      <div class="scroll-theme add-Item-detail-scroll">
        <v-form lazy-validation ref="headerForm">
          <template>
            <p style="font-size: 32px; font-weight: 700" class="mb-0">ITEM</p>
            <v-row no-gutters class="standard-row mb-7">
              <v-col
                v-for="(field, title, index) in detailItem.Item"
                :key="`title_${index}`"
                cols="12"
                sm="6"
                md="6"
                lg="6"
                class="mt-3 mt-md-1"
                style="font-size: 14px"
              >
                <v-row no-gutters class="standard-row">
                  <!-- LABEL -->
                  <v-col cols="12" md="6" style="font-weight: 700">
                    <v-icon v-show="windowSize.x < 960" size="15"
                      >mdi-play</v-icon
                    >
                    {{ title }}
                  </v-col>

                  <!-- VIEW MODE -->
                  <v-col v-if="!editFile" cols="12" md="6" class="pr-5">
                    <span v-show="windowSize.x < 960"
                      >&nbsp;&nbsp;&nbsp;&nbsp;</span
                    >
                    {{ displayValue(field) }}
                  </v-col>

                  <!-- EDIT : TYPE OF VENDOR -->
                   <v-col
                    v-else-if="field === 'type_of_vendor'"
                    cols="12"
                    md="6"
                    class="pr-sm-3"
                  >
                    <v-autocomplete
                      v-model="dataInputs.type_of_vendor"
                      :items="typeOfVendorList"
                      item-text="type"
                      item-value="type"
                      multiple
                      outlined
                      dense
                      hide-details
                      class="dropdown-select-gl"
                      append-icon="mdi-chevron-down"
                      :rules="textRulesMultiple"
                      required 
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    v-else-if="field === 'material_name'"
                    cols="12"
                    md="6"
                    class="pr-sm-3"
                  >
                   <v-autocomplete :items="materialData" v-model="selectedMaterial" return-object
                    item-text="material_name" outlined dense hide-details class="dropdown-select-gl"
                    append-icon="mdi-chevron-down" color="black" :loading="loadingMaterial" :rules="textRules" required>
                    <template v-slot:item="data">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{
                          data.item.material_name}}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="font-theme"
                            style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  </v-col>
                  <v-col v-else-if="field === 'material_code'"  cols="12"
                    md="6"
                    class="pr-sm-3">
                  <v-text-field hide-details outlined height="25" v-model="dataInputs.material_code" type="text"
                    color="black" class="py-0 font-theme border-radius-box margin-left-text-field" readonly />
                  </v-col>
                  <!-- EDIT : COST CENTER -->
                  <v-col
                    v-else-if="field === 'cost_center'"
                    cols="12"
                    md="6"
                    class="pr-sm-3"
                  >
                    <v-autocomplete
                      v-model="dataInputs.cost_center"
                      :items="costCenterList"
                      item-text="cost_center_type"
                      item-value="cost_center_type"
                      multiple
                      outlined
                      dense
                      hide-details
                      class="dropdown-select-gl"
                      append-icon="mdi-chevron-down"
                      :rules="textRulesMultiple"
                      required 
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- EDIT : TEXT -->
                  <v-col v-else  cols="12"
                    md="6"
                    class="pr-sm-3">
                    <v-text-field
                      v-model="dataInputs[field]"
                      hide-details
                      outlined
                      height="25"
                      class="py-0 font-theme border-radius-box margin-left-text-field"
                      :rules="textRules"
                      required 
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "../EventBus";
import {  materialList } from '@/functions/materialService.js'
export default {
  data: () => ({
    textRules: [v => !!v],
    textRulesMultiple: [
        v => Array.isArray(v) && v.length > 0 || 'กรุณาเลือก'
    ],
    dialog: false,
    loadingAddItem: false,
    selectedMaterial: null,
    loadingMaterial: false,
    materialData:[],
    originalDataInputs: {},
    isReady: false,
    editFile: false,
    permissionEdit: false,
    windowSize: { x: 0 },
    costCenterList: [
      { cost_center_type: "D" },
      { cost_center_type: "E" },
      { cost_center_type: "B" },
      { cost_center_type: "S" },
      { cost_center_type: "M" },
    ],

    typeOfVendorList: [
      { type: "Other" },
      { type: "ย่อย" },
      { type: "ร่วม-ร่วมค้า-ผู้ถือหุ้น" },
    ],
  }),
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.editFile = false;
        this.dialog = false;
        this.selectedMaterial = null
      }
    },
    selectedMaterial(val) {
    if (!val) {
      this.dataInputs.material_name = ''
      this.dataInputs.material_code = ''
      return
    }
    this.dataInputs.material_name = val.material_name
    this.dataInputs.material_code = val.material_code
  }
  },
  computed: {
    selectedBiz() {
      return this.$store.state.confirmSelectedBiz;
    },
    permissionBtnEditMode() {
      return this.$store.state.permissionBtnEditMode;
    },
    permissionGlAccount(){
      return this.$store.state.permissionGlAccount
    }
  },
  mounted() {
    EventBus.$on("openDetailGlAccount", this.openDialog);
  },
  beforeDestroy() {
    EventBus.$off("openDetailGlAccount");
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth };
    },
    openDialog(item) {
      this.dialog = true;
      this.isReady = true;
      this.detailItem = {
        Item: {
          "Material Name": "material_name",
          "Material Code": "material_code",
          "Cost Center": "cost_center",
          "Gl Code New": "gl_code_new",
          "Gl Account Name New": "gl_account_name_new",
          "Type Of Vendor": "type_of_vendor",
        },
      };

      this.dataInputs = {
        _id: item._id,
        tax_id: item.tax_id,
        material_code: item.material_code,
        material_name: item.material_name,
        gl_code_new: item.gl_code_new,
        gl_account_name_new: item.gl_account_name_new,

        cost_center: (Array.isArray(item.cost_center)
          ? item.cost_center
          : typeof item.cost_center === "string"
          ? item.cost_center.split(",").map((v) => v.trim())
          : []
        ).map((cc) => (typeof cc === "string" ? cc : cc.cost_center_type)),

        type_of_vendor: (Array.isArray(item.type_of_vendor)
          ? item.type_of_vendor
          : typeof item.type_of_vendor === "string"
          ? item.type_of_vendor.split(",").map((v) => v.trim())
          : []
        ).map((tv) => (typeof tv === "string" ? tv : tv.type)),
      };
      this.materialData = materialList
      this.selectedMaterial = this.materialData.find(m => m.material_code === item.material_code) || null
      this.originalDataInputs = JSON.parse(JSON.stringify(this.dataInputs));
    },
    async saveEditItem() {
      if (!this.$refs.headerForm.validate()) return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
      this.loadingAddItem = true;
      try {
        const payload = {
          _id: this.dataInputs._id,
          tax_id: this.dataInputs.tax_id,
          material_code: this.dataInputs.material_code,
          material_name: this.dataInputs.material_name,
          cost_center: this.dataInputs.cost_center.map((e) => ({
            cost_center_type: e,
          })),
          gl_code_new: this.dataInputs.gl_code_new,
          gl_account_name_new: this.dataInputs.gl_account_name_new,
          type_of_vendor: this.dataInputs.type_of_vendor.map((e) => ({
            type: e,
          })),
        };
        const { data } = await this.axios.put(
          `${this.$api_url}/gl_account/api/v1/update_gl_account`,
          payload
        );
        if (data.status) {
          this.dialog = false;
          this.editFile = false;
          this.alert("เพิ่มข้อมูลสำเร็จ", "Success", "success");
          setTimeout(() => {
            EventBus.$emit("reloadGlAccountPage");
          }, 1000);
        } else {
          this.alert("เพิ่มข้อมูลไม่สำเร็จ", "Fail", "error");
        }
      } catch (error) {
        this.alert("เพิ่มข้อมูลไม่สำเร็จ", "Fail", "error");
        console.log(error);
      } finally {
        this.loadingAddItem = false;
      }
    },
    displayValue(field) {
      const value = this.dataInputs[field];

      if (field === "cost_center" && Array.isArray(value)) {
        return value.join(", ");
      }

      if (field === "type_of_vendor" && Array.isArray(value)) {
        return value.join(", ");
      }

      return value || "-";
    },
    editFileData() {
      this.editFile = true;
    },
    cancelEdit() {
      this.dataInputs = JSON.parse(JSON.stringify(this.originalDataInputs));
       this.selectedMaterial =
       this.materialData.find(
          m => m.material_code === this.originalDataInputs.material_code
        ) || null
      this.editFile = false;
    },

    alert(title = "", text = "Fail", icon = "info") {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: `<b class="alert-success-title">${title}</b>`,
        text: text,
        showClass: {
          popup: "animate-show-card",
        },
        customClass: {
          container: "alert-card-block",
          popup: "alert-card-success",
          title: "alert-title-block",
          htmlContainer: "alert-text-box",
          icon: "alert-icon",
        },
      });
    },
  },
};
</script>

<style>
.Item-detail-scroll {
  overflow-y: auto;
  border-radius: 0px !important;
  max-height: calc(100vh - 158px);
}

.custom-text-field {
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .Item-detail-scroll {
    max-height: calc(100vh - 238px) !important;
  }
}
</style>
